module.exports = __webpack_public_path__ + "components/page-header/static/icon-x-873ab17d4e9645c57361d8ee600943eb.svg";